import React from 'react';
import App from './container/App';
import HomePage from './components/home/HomePage';
import LoginPage from './components/auth/LoginPage';
import TimeSheetContainer from './container/TimeSheetContainer';
import NewTaskContainer from './container/TimeSheetContainer/NewTaskContainer';
import ProjectContainer from './container/ProjectContainer';
import UserContainer from './container/UserContainer';
import NewProjectContainer from './container/ProjectContainer/NewProjectContainer';
import ManageProjectContainer from './container/ProjectContainer/ManageProjectContainer';
import UserPopinContainer from './container/UserPopinContainer';
import UserPasswordPopinContainer from './container/UserPasswordPopinContainer';

import AuthApi from './api/authApi';

const redirectToLogin = (nextState, replace, callback) => {
    if (!AuthApi.isLoggedIn()) {
        replace('/login');
    }
    callback();
};

const routes = {
    path: '/',
    component: App,
    indexRoute: {
        component: HomePage,
        onEnter: redirectToLogin
    },
    childRoutes: [
        {
            path: '/login',
            component: LoginPage
        },
        {
            path: '/project',
            component: ProjectContainer,
            onEnter: redirectToLogin,
            childRoutes: [
                {
                    path: 'new',
                    component: NewProjectContainer
                }
            ]
        },
        {
            path: '/project/:projectId/manage',
            component: ManageProjectContainer
        },
        {
            onEnter: redirectToLogin,
            path: '/timeSheet/:timeSheet',
            component: TimeSheetContainer,
            childRoutes: [{
                onEnter: function () {
                },
                path: 'new',
                component: NewTaskContainer
            }, {
                onEnter: function () {
                },
                path: 'edit/:taskId',
                component: NewTaskContainer
            }]
        },
        {
            path: '/user',
            component: UserContainer,
            onEnter: redirectToLogin,
            childRoutes: [
                {
                    path: 'new',
                    component: UserPopinContainer
                },
                {
                    path: ':user/edit',
                    component: UserPopinContainer
                },
                {
                    path: ':user/password',
                    component: UserPasswordPopinContainer
                }
            ]
        },
        {
            path: '*',
            onEnter: function () {
            }
            //component: PageNotFound
        }
    ]
};

export default routes;


/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/